export const REWARDS = {
  FETCH_LIST: {
    LOAD: 'REWARDS_FETCH_LIST',
    SUCCESS: 'REWARDS_FETCH_LIST_SUCCESS',
    FAIL: 'REWARDS_FETCH_LIST_FAIL'
  },
  FETCH_DETAIL: {
    LOAD: 'REWARDS_FETCH_DETAIL',
    SUCCESS: 'REWARDS_FETCH_DETAIL_SUCCESS',
    FAIL: 'REWARDS_FETCH_DETAIL_FAIL'
  },
  CREATE: {
    LOAD: 'REWARDS_CREATE',
    SUCCESS: 'REWARDS_CREATE_SUCCESS',
    FAIL: 'REWARDS_CREATE_FAIL'
  },
  UPDATE_STATUS: {
    LOAD: 'REWARDS_UPDATE_STATUS',
    SUCCESS: 'REWARDS_UPDATE_STATUS_SUCCESS',
    FAIL: 'REWARDS_UPDATE_STATUS_FAIL'
  },
  CLEAR_MESSAGE: 'REWARDS_CLEAR_MESSAGE',
  CLEAR_CREATE: 'REWARDS_CLEAR_CREATE'
};

export const fetchRewardsCampaigns = filters => ({
  type: REWARDS.FETCH_LIST.LOAD,
  filters
});

export const fetchRewardsCampaignDetail = id => ({
  type: REWARDS.FETCH_DETAIL.LOAD,
  id
});

export const createRewardsCampaign = (form, userKey) => ({
  type: REWARDS.CREATE.LOAD,
  form,
  userKey
});

export const updateRewardsCampaignStatus = (id, status) => ({
  type: REWARDS.UPDATE_STATUS.LOAD,
  id,
  status
});

export const clearRewardsMessage = () => ({
  type: REWARDS.CLEAR_MESSAGE
});

export const clearRewardsCreate = () => ({
  type: REWARDS.CLEAR_CREATE
});
